// Animated "casita en movimiento" — la fábrica de Travel Empire
// Equipo trabajando, engranajes, humo y banda transportadora que saca clientes.
const TravelEmpireFactory = () => {
  return (
    <div className="tef-wrap" data-testid="travel-empire-factory">
      <style>{`
        .tef-wrap{width:100%;max-width:720px;margin:0 auto}
        .tef-wrap svg{display:block;width:100%;height:auto}
        @keyframes tf-spin{to{transform:rotate(360deg)}}
        @keyframes tf-spinr{to{transform:rotate(-360deg)}}
        @keyframes tf-bob{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}
        @keyframes tf-carry{from{transform:translateX(0)}to{transform:translateX(450px)}}
        @keyframes tf-smoke{0%{opacity:0;transform:translateY(0) scale(.6)}25%{opacity:.5}100%{opacity:0;transform:translateY(-46px) scale(1.4)}}
        @keyframes tf-pop{0%,100%{transform:scale(1)}50%{transform:scale(1.18)}}
        @keyframes tf-drop{0%{transform:translateY(-6px);opacity:0}25%{opacity:1}100%{transform:translateY(34px);opacity:0}}
        .tef-wrap .tf-gear,.tef-wrap .tf-roll,.tef-wrap .tf-worker,.tef-wrap .tf-token,.tef-wrap .tf-smoke,.tef-wrap .tf-pop,.tef-wrap .tf-drop{transform-box:fill-box;will-change:transform,opacity}
        .tef-wrap .tf-gear{transform-origin:center;animation:tf-spin 6s linear infinite}
        .tef-wrap .tf-gear.r{animation:tf-spinr 4.5s linear infinite}
        .tef-wrap .tf-roll{transform-origin:center;animation:tf-spin 2.4s linear infinite}
        .tef-wrap .tf-worker{transform-origin:center bottom;animation:tf-bob 1.8s ease-in-out infinite}
        .tef-wrap .tf-token{animation:tf-carry 8s linear infinite}
        .tef-wrap .tf-smoke{transform-origin:center;animation:tf-smoke 3s ease-out infinite}
        .tef-wrap .tf-pop{transform-origin:center;animation:tf-pop 1.5s ease-in-out infinite}
        .tef-wrap .tf-drop{animation:tf-drop 2.2s ease-in infinite}
        @media (prefers-reduced-motion: reduce){
          .tef-wrap .tf-gear,.tef-wrap .tf-gear.r,.tef-wrap .tf-roll,.tef-wrap .tf-worker,.tef-wrap .tf-token,.tef-wrap .tf-smoke,.tef-wrap .tf-pop,.tef-wrap .tf-drop{animation:none!important}
        }
      `}</style>
      <svg viewBox="0 0 820 400" role="img" aria-label="La fábrica de Travel Empire: un equipo de más de 30 personas trabajando para crear clientes cada día">
        <defs>
          <clipPath id="tefbeltclip"><rect x="210" y="304" width="430" height="62" /></clipPath>
        </defs>
        <rect x="40" y="352" width="740" height="6" rx="3" fill="#dbe6f0" />
        <rect x="298" y="24" width="224" height="32" rx="16" fill="#E23744" />
        <text x="410" y="45" textAnchor="middle" fontFamily="Manrope,Lexend,sans-serif" fontWeight="800" fontSize="15" fill="#fff">+30 PERSONAS TRABAJANDO</text>
        <text x="410" y="80" textAnchor="middle" fontFamily="Lexend,sans-serif" fontWeight="600" fontSize="13" fill="#6b7787">Los leads entran desde tus redes</text>

        <g transform="translate(250,86)">
          <rect x="0" y="0" width="30" height="30" rx="9" fill="#E1306C" />
          <rect x="6.5" y="6.5" width="17" height="17" rx="6" fill="none" stroke="#fff" strokeWidth="2.4" />
          <circle cx="15" cy="15" r="4.4" fill="none" stroke="#fff" strokeWidth="2.4" />
          <circle cx="21.3" cy="8.7" r="1.7" fill="#fff" />
        </g>
        <g className="tf-drop" style={{ animationDelay: '0s' }}><circle cx="265" cy="122" r="5.5" fill="#E1306C" /></g>

        <g transform="translate(320,86)">
          <rect x="0" y="0" width="30" height="30" rx="9" fill="#1877F2" />
          <path d="M18.6 30 v-9 h3 l.6-3.6 h-3.6 v-2.2 c0-1 .5-1.9 2-1.9 h1.8 v-3.1 s-1.6-.3-3.2-.3 c-3.2 0-5.1 1.9-5.1 5.2 v2.3 h-3.3 v3.6 h3.3 v9 z" fill="#fff" />
        </g>
        <g className="tf-drop" style={{ animationDelay: '.5s' }}><circle cx="335" cy="122" r="5.5" fill="#1877F2" /></g>

        <g transform="translate(470,86)">
          <rect x="0" y="0" width="30" height="30" rx="9" fill="#25D366" />
          <path d="M15 6.5 a8.5 8.5 0 0 0 -7.3 12.8 L6.5 24 l4.9 -1.2 A8.5 8.5 0 1 0 15 6.5 z" fill="#fff" />
        </g>
        <g className="tf-drop" style={{ animationDelay: '1s' }}><circle cx="485" cy="122" r="5.5" fill="#25D366" /></g>

        <g transform="translate(540,86)">
          <rect x="0" y="0" width="30" height="30" rx="9" fill="#010101" />
          <path d="M18.4 15.7 a5.6 5.6 0 1 1 -4.9 -5.55 v2.95 a2.7 2.7 0 1 0 1.9 2.6 V4.6 h2.85 a4.3 4.3 0 0 0 4 3.85 v2.85 a7.1 7.1 0 0 1 -4-1.25 v5.5 a5.6 5.6 0 0 1 -5.6 5.6 z" fill="#fff" />
        </g>
        <g className="tf-drop" style={{ animationDelay: '1.5s' }}><circle cx="555" cy="122" r="5.5" fill="#25F4EE" stroke="#010101" strokeWidth="1.5" /></g>

        <polygon points="250,172 332,132 488,132 570,172" fill="#E23744" />
        <rect x="360" y="104" width="20" height="34" rx="4" fill="#3a5fb0" />
        <rect x="392" y="94" width="20" height="44" rx="4" fill="#3a5fb0" />
        <g fill="#cbd8ec">
          <circle className="tf-smoke" style={{ animationDelay: '0s' }} cx="370" cy="102" r="8" />
          <circle className="tf-smoke" style={{ animationDelay: '1.2s' }} cx="370" cy="102" r="6" />
          <circle className="tf-smoke" style={{ animationDelay: '.5s' }} cx="402" cy="92" r="8" />
          <circle className="tf-smoke" style={{ animationDelay: '1.7s' }} cx="402" cy="92" r="6" />
        </g>

        <rect x="250" y="170" width="320" height="162" rx="16" fill="#2b6fd6" />
        <rect x="250" y="170" width="320" height="30" rx="16" fill="#2560bd" />

        <g className="tf-gear">
          <circle cx="300" cy="238" r="30" fill="#eaf1fb" />
          <circle cx="300" cy="238" r="30" fill="none" stroke="#bcd0ec" strokeWidth="9" strokeDasharray="8 10" />
          <circle cx="300" cy="238" r="11" fill="#2b6fd6" />
        </g>
        <g className="tf-gear r">
          <circle cx="346" cy="216" r="20" fill="#eaf1fb" />
          <circle cx="346" cy="216" r="20" fill="none" stroke="#bcd0ec" strokeWidth="7" strokeDasharray="6 8" />
          <circle cx="346" cy="216" r="7" fill="#E23744" />
        </g>

        <path d="M402 246 v-40 a22 22 0 0 1 44 0 v40 z" fill="#dbe8fb" />
        <path d="M458 246 v-40 a22 22 0 0 1 44 0 v40 z" fill="#dbe8fb" />
        <path d="M514 246 v-40 a22 22 0 0 1 44 0 v40 z" fill="#dbe8fb" />

        <g className="tf-worker" style={{ animationDelay: '0s' }}>
          <rect x="415" y="222" width="18" height="22" rx="7" fill="#173a6b" /><circle cx="424" cy="216" r="7" fill="#f0c9a8" /><path d="M415 215 a9 7 0 0 1 18 0 z" fill="#E23744" />
        </g>
        <g className="tf-worker" style={{ animationDelay: '.6s' }}>
          <rect x="471" y="222" width="18" height="22" rx="7" fill="#173a6b" /><circle cx="480" cy="216" r="7" fill="#f0c9a8" /><path d="M471 215 a9 7 0 0 1 18 0 z" fill="#E23744" />
        </g>
        <g className="tf-worker" style={{ animationDelay: '1.2s' }}>
          <rect x="527" y="222" width="18" height="22" rx="7" fill="#173a6b" /><circle cx="536" cy="216" r="7" fill="#f0c9a8" /><path d="M527 215 a9 7 0 0 1 18 0 z" fill="#E23744" />
        </g>

        <g className="tf-worker" style={{ animationDelay: '.9s' }}>
          <rect x="266" y="300" width="18" height="22" rx="7" fill="#173a6b" /><circle cx="275" cy="294" r="7" fill="#f0c9a8" /><path d="M266 293 a9 7 0 0 1 18 0 z" fill="#ffffff" />
          <rect x="283" y="300" width="4" height="14" rx="2" fill="#8fa8cb" transform="rotate(38 285 307)" />
        </g>
        <g className="tf-worker" style={{ animationDelay: '1.5s' }}>
          <rect x="316" y="300" width="18" height="22" rx="7" fill="#1f4f8f" /><circle cx="325" cy="294" r="7" fill="#f0c9a8" /><path d="M316 293 a9 7 0 0 1 18 0 z" fill="#E23744" />
        </g>

        <g className="tf-worker" style={{ animationDelay: '.3s' }}>
          <rect x="150" y="330" width="18" height="22" rx="7" fill="#173a6b" /><circle cx="159" cy="324" r="7" fill="#f0c9a8" /><path d="M150 323 a9 7 0 0 1 18 0 z" fill="#ffffff" />
          <rect x="146" y="312" width="26" height="16" rx="3" fill="#c98a4a" /><line x1="146" y1="320" x2="172" y2="320" stroke="#a76f38" strokeWidth="2" />
        </g>

        <g className="tf-worker" style={{ animationDelay: '1.1s' }}>
          <rect x="640" y="330" width="18" height="22" rx="7" fill="#1f4f8f" /><circle cx="649" cy="324" r="7" fill="#f0c9a8" /><path d="M640 323 a9 7 0 0 1 18 0 z" fill="#E23744" />
        </g>

        <text x="606" y="322" textAnchor="middle" fontFamily="Lexend,sans-serif" fontWeight="600" fontSize="13" fill="#6b7787">Salen clientes</text>

        <rect x="200" y="338" width="452" height="16" rx="8" fill="#1b2a44" />
        <g stroke="#6f88b4" strokeWidth="3" strokeLinecap="round">
          <g className="tf-roll"><line x1="220" y1="346" x2="234" y2="346" /><line x1="227" y1="339" x2="227" y2="353" /></g>
          <g className="tf-roll"><line x1="278" y1="346" x2="292" y2="346" /><line x1="285" y1="339" x2="285" y2="353" /></g>
          <g className="tf-roll"><line x1="336" y1="346" x2="350" y2="346" /><line x1="343" y1="339" x2="343" y2="353" /></g>
          <g className="tf-roll"><line x1="394" y1="346" x2="408" y2="346" /><line x1="401" y1="339" x2="401" y2="353" /></g>
          <g className="tf-roll"><line x1="452" y1="346" x2="466" y2="346" /><line x1="459" y1="339" x2="459" y2="353" /></g>
          <g className="tf-roll"><line x1="510" y1="346" x2="524" y2="346" /><line x1="517" y1="339" x2="517" y2="353" /></g>
          <g className="tf-roll"><line x1="568" y1="346" x2="582" y2="346" /><line x1="575" y1="339" x2="575" y2="353" /></g>
          <g className="tf-roll"><line x1="626" y1="346" x2="640" y2="346" /><line x1="633" y1="339" x2="633" y2="353" /></g>
        </g>

        <g clipPath="url(#tefbeltclip)">
          <g className="tf-token" style={{ animationDelay: '0s' }}>
            <circle cx="205" cy="326" r="15" fill="#ffffff" stroke="#2b6fd6" strokeWidth="3" /><circle cx="205" cy="322" r="4" fill="#2b6fd6" /><path d="M197 332 a8 8 0 0 1 16 0 z" fill="#2b6fd6" />
          </g>
          <g className="tf-token" style={{ animationDelay: '-1.6s' }}>
            <circle cx="205" cy="326" r="15" fill="#ffffff" stroke="#E23744" strokeWidth="3" /><circle cx="205" cy="322" r="4" fill="#E23744" /><path d="M197 332 a8 8 0 0 1 16 0 z" fill="#E23744" />
          </g>
          <g className="tf-token" style={{ animationDelay: '-3.2s' }}>
            <circle cx="205" cy="326" r="15" fill="#ffffff" stroke="#2b6fd6" strokeWidth="3" /><circle cx="205" cy="322" r="4" fill="#2b6fd6" /><path d="M197 332 a8 8 0 0 1 16 0 z" fill="#2b6fd6" />
          </g>
          <g className="tf-token" style={{ animationDelay: '-4.8s' }}>
            <circle cx="205" cy="326" r="15" fill="#ffffff" stroke="#E23744" strokeWidth="3" /><circle cx="205" cy="322" r="4" fill="#E23744" /><path d="M197 332 a8 8 0 0 1 16 0 z" fill="#E23744" />
          </g>
          <g className="tf-token" style={{ animationDelay: '-6.4s' }}>
            <circle cx="205" cy="326" r="15" fill="#ffffff" stroke="#2b6fd6" strokeWidth="3" /><circle cx="205" cy="322" r="4" fill="#2b6fd6" /><path d="M197 332 a8 8 0 0 1 16 0 z" fill="#2b6fd6" />
          </g>
        </g>

        <text className="tf-pop" x="700" y="292" textAnchor="middle" fontFamily="Manrope,sans-serif" fontWeight="800" fontSize="20" fill="#E23744">+1</text>
        <line x1="700" y1="318" x2="688" y2="304" stroke="#173a6b" strokeWidth="5" strokeLinecap="round" />
        <line x1="700" y1="318" x2="712" y2="304" stroke="#173a6b" strokeWidth="5" strokeLinecap="round" />
        <rect x="691" y="314" width="18" height="22" rx="7" fill="#173a6b" />
        <circle cx="700" cy="308" r="8" fill="#f0c9a8" />
        <text x="700" y="352" textAnchor="middle" fontFamily="Lexend,sans-serif" fontWeight="700" fontSize="12" fill="#2b6fd6">¡Cliente nuevo!</text>
      </svg>
    </div>
  );
};

export default TravelEmpireFactory;
